module.exports = __webpack_public_path__ + "media/images/lb/156-e2ac51b8fcec7a84f9a3161d75f1fce7.svg";